import React from 'react';
import moment from 'moment';
import { get } from 'lodash';
import { Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { dataCorrectionType, listDefaultValues } from '../../../store/repiStore';

import Warning from '../../../img/icons/Warning';

import '../repi.scss';

const DATE_FORMAT = "DD.MM.YYYY";

class RepiDataCorrectionUpdatesPopup extends React.Component {
    get elements() {
        return React.Children.toArray(this.props.data.elements).filter(f => !isNullOrUndefined(f));
    }

    state = { procesing: false };

    render() {
        const { data } = this.props;
        if (isNullOrUndefined(data) || isNullOrUndefined(data.elements) || isNullOrUndefined(data.values))
            return null;

        return (
            <div style={{ marginBottom: "1.5em" }}>
                {!isNullOrUndefined(data.values.updateRequests) && data.values.updateRequests.length > 0 && <div>
                    <table className="repi-data-correction-table fixed">
                        <thead>
                            <tr>
                                {this.elements.map(ch => React.cloneElement(ch, { isHeader: true, sectionId: data.sectionId }))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="repi-data-correction-table-row current-values">
                                {this.elements.map(ch => {
                                    return React.cloneElement(ch, {
                                        rowId: 1,
                                        sectionId: data.sectionId,
                                        value: this.getValue(data.values, ch.props),
                                        error: null,
                                        isPending: false,
                                        textOnly: true
                                    })
                                })}
                            </tr>
                            {data.values.updateRequests.map((v, i) => <tr key={`pending-${i}`} className="repi-data-correction-table-row pending-update">
                                {this.elements.map(ch => {
                                    const value = get(v, ch.props.name, "");
                                    return React.cloneElement(ch, {
                                        rowId: 1,
                                        sectionId: data.sectionId,
                                        value: ch.props.type === dataCorrectionType.date ? this.formatDate(value) : value,
                                        error: null,
                                        isPending: true,
                                        textOnly: true
                                    })
                                })}
                            </tr>)}
                        </tbody>
                    </table>
                </div>}
                {data.values.deleteRequest === true && <div style={{ marginTop: "1.5em", color: "#FF3860" }}>
                    <span className="ml-link update-warning" style={{ marginRight: "0.5em" }}>
                        <Warning className="ml-link-icon"/>
                    </span>
                    <Translate id="Repi.Report.DataCorrection.PendingRequests.Delete" />
                </div>}
            </div>
        );
    }

    getValue = (values, props) => {
        const value = get(values, props.name, "");

        if (props.type === dataCorrectionType.date)
            return this.formatDate(value);

        if (props.type === dataCorrectionType.list) {
            if (props.name === "dunningLevel" && value === listDefaultValues.dunningLevel)
                return "";
        }

        return value;
    }

    formatDate = (value) => {
        if (isNullOrUndefined(value))
            return "";

        const d = new Date(value);
        if (isNaN(d.getTime()))
            return "";

        return moment(d).format(DATE_FORMAT);
    }
}

export default (RepiDataCorrectionUpdatesPopup);